import React from 'react';
import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { UserLoader } from '../middleware/UserLoader';
import { ProtectedRoute } from '../ProtectedRoute';

const StaffFacesheet = loadable(
  () => import('@/pages/AdminHub/Staff/StaffFacesheet')
); // prettier-ignore
const StaffSystemPermissions = loadable(
  () => import('@/pages/AdminHub/Staff/StaffSystemPermissions')
); // prettier-ignore
const StaffPage = loadable(() => import('@/pages/AdminHub/Staff'));
const StaffAccess = loadable(
  () => import('@/pages/AdminHub/Staff/StaffAccess')
); // prettier-ignore
const StaffAccessResidents = loadable(
  () => import('@/pages/AdminHub/Staff/StaffAccess/StaffAccessResidents')
); // prettier-ignore
const StaffAccessCommunity = loadable(
  () => import('@/pages/AdminHub/Staff/StaffAccess/StaffAccessCommunity')
); // prettier-ignore
const StaffNotificationPreferences = loadable(
  () => import('@/pages/AdminHub/Staff/Notifications')
); // prettier-ignore

export enum StaffRoutes {
  Staff = '/:domain/admin-hub/staff',
  StaffFacesheet = '/:domain/admin-hub/staff/:staff_id/facesheet',
  StaffAccess = '/:domain/admin-hub/staff/:staff_id/access',
  StaffAccessResidents = '/:domain/admin-hub/staff/:staff_id/access/residents',
  StaffAccessCommunity = '/:domain/admin-hub/staff/:staff_id/access/community',
  StaffSystemPermissions = '/:domain/admin-hub/staff/:staff_id/system-permissions',
  StaffUserSettingsPage = '/:domain/admin-hub/staff/:staff_id/user-settings',
  StaffNotificationPreferences = '/:domain/admin-hub/staff/:staff_id/notification-preferences'
}

export const getStaffRoutes = (): RouteObject[] => {
  return [
    {
      path: StaffRoutes.Staff,
      element: (
        <UserLoader>
          <ProtectedRoute component={StaffPage} role="L1" />
        </UserLoader>
      ),
      children: [
        {
          path: StaffRoutes.StaffFacesheet,
          element: <StaffFacesheet />
        },
        {
          path: StaffRoutes.StaffAccess,
          element: <StaffAccess />,
          children: [
            {
              path: StaffRoutes.StaffAccessCommunity,
              element: <StaffAccessCommunity />
            },
            {
              path: StaffRoutes.StaffAccessResidents,
              element: <StaffAccessResidents />
            }
          ]
        },
        {
          path: StaffRoutes.StaffSystemPermissions,
          element: <StaffSystemPermissions />
        },
        {
          path: StaffRoutes.StaffNotificationPreferences,
          element: (
            <ProtectedRoute
              role="L1"
              component={StaffNotificationPreferences}
            />
          )
        }
      ]
    }
  ];
};
